import 'babel-polyfill'
import Vue from 'vue'
import router from './router'
import VueTk from '@moke/vue-tk'
import App from './App.vue'
import config from './config'
import './assets/scss/main.scss'
import 'vant/lib/index.css'
import store from '../src/store/index'
import animate from 'animate.css'

import { Lazyload, Tag } from 'vant'

// 引用cleave.js插件
import Cleave from 'vue-cleave-component'
// 引用autosize插件
import TextareaAutosize from 'vue-textarea-autosize'
// 引用裁剪图片组件
import VuejsClipper from 'vuejs-clipper'
import VueRx from 'vue-rx'

Vue.use(Cleave)

// 注册时可以配置额外的选项
Vue.use(Lazyload)
Vue.use(Tag)

Vue.use(TextareaAutosize)
Vue.use(VueRx)
Vue.use(animate)
Vue.use(VuejsClipper, {
  components: {
    clipperFixed: true, // 移动图片裁剪
    clipperBasic: true, // 移动边框裁剪
    clipperPreview: true // 预览图片
  }
})

Vue.config.productionTip = false

let plusReady = new Promise((resolve) => {
  if (!VueTk.tkUa.isPlus) resolve()
  if (window.plus) resolve()
  document.addEventListener('plusready', resolve, false)
})

async function init () {
  for (let pluginName of config.plugins) {
    let plugin = require('./plugins/' + pluginName)
    if (plugin && plugin.default && typeof plugin.default === 'function') {
      await plugin.default()
    }
  }
  await plusReady
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
init()
